import { useAuthorization } from '../contexts/AuthorizationContext';

type Microservicio = 'employee' | 'timekeeper' | 'scheduled' | 'pdh-core' | 'reports';

interface PermisoSistema {
    name: string;
    permission: string;
    microservicio: Microservicio;
    // Aún no existe en el flujo de auth: se documenta pero no se exige.
    pendiente?: boolean;
}

type MapaPermisos<Accion extends string> = Record<Accion, readonly PermisoSistema[]>;

const crearPermisos = <Accion extends string>(mapa: MapaPermisos<Accion>) => {
    const getPermisos = (accion: Accion): string[] => [...new Set(mapa[accion].filter((permiso) => !permiso.pendiente).map((permiso) => permiso.permission))];

    // Si todos los permisos de la acción están pendientes, la acción queda habilitada.
    const usePermiso = (accion: Accion): boolean => {
        const { can } = useAuthorization();
        const permisos = getPermisos(accion);
        return permisos.length === 0 || can(permisos);
    };

    return { getPermisos, usePermiso };
};

export { crearPermisos };
export type { PermisoSistema, MapaPermisos, Microservicio };
